import envelope_icon from "../img/envelope.webp";
import facebook_icon from "../img/facebook.webp";
import linkedin_icon from "../img/linkedin.webp";
import telegram_icon from "../img/telegram.webp";
import viber_icon from "../img/viber.webp";
import whatsapp_icon from "../img/whatsapp.webp";
import x_icon from "../img/x.webp";

export const SOCIAL_NETWORKS = (url: string) => [
  {
    img: facebook_icon,
    labelKey: "facebook",
    href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  },
  {
    img: viber_icon,
    labelKey: "viber",
    href: `viber://forward?text=${encodeURIComponent(url)}`,
  },
  {
    img: linkedin_icon,
    labelKey: "linkedin",
    href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
  },
  {
    img: whatsapp_icon,
    labelKey: "whatsapp",
    href: `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`,
  },
  {
    img: x_icon,
    labelKey: "x",
    href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
  },
  {
    img: telegram_icon,
    labelKey: "telegram",
    href: `https://t.me/share/url?url=${encodeURIComponent(url)}`,
  },
  {
    img: envelope_icon,
    labelKey: "email",
    href: `mailto:?subject=Check out this event&body=${encodeURIComponent(url)}`,
  },
];
